import { render, staticRenderFns } from "./DoInstallationPage.vue?vue&type=template&id=835edeb6"
import script from "./DoInstallationPage.vue?vue&type=script&lang=js"
export * from "./DoInstallationPage.vue?vue&type=script&lang=js"
import style0 from "./DoInstallationPage.vue?vue&type=style&index=0&id=835edeb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports